import type { NavigationSettings } from "@shared/config/navigation";
import { adminHttp } from "@shared/lib/http";
import { isStubEnabled } from "@sdk/core";

export const navigationQueryKey = (tenantId: string | null | undefined) =>
  ["admin.navigation", tenantId] as const;

export async function loadNavigation(): Promise<NavigationSettings> {
  if (isStubEnabled()) {
    const { loadSettings } = await import("@features/settings/api/settings");
    return (await loadSettings()).navigation ?? { visibility: {} };
  }
  return adminHttp.get<NavigationSettings>("/api/admin/navigation");
}
